import { MutationTree } from "vuex";
import { IPermissionsState } from "@/core/interfaces/permissionsState.interface";
import {
  IPermission,
  IPermissionCategory,
} from "@/core/interfaces/permission.interface";

const flattenPermissions = (
  categories: IPermissionCategory[],
): IPermission[] => {
  return categories.flatMap((category) =>
    (category.permissions || []).map((permission) => ({
      ...permission,
      auto_select_permissions: permission.auto_select_permissions || [],
    })),
  );
};

const mutations: MutationTree<IPermissionsState> = {
  fetchingPermissions(state, fetching: boolean) {
    state.isFetchingPermission = fetching;
  },
  fetchPermissionsSuccess(state, payload: IPermissionCategory[] | IPermission[]) {
    state.isFetchingPermission = false;
    if (
      Array.isArray(payload) &&
      payload.length > 0 &&
      "category" in payload[0] &&
      "permissions" in payload[0]
    ) {
      const categories = payload as IPermissionCategory[];
      state.permissionCategories = categories;
      state.permissions = flattenPermissions(categories);
      return;
    }

    const permissions = (payload as IPermission[]).map((permission) => ({
      ...permission,
      auto_select_permissions: permission.auto_select_permissions || [],
    }));
    state.permissions = permissions;
    state.permissionCategories = permissions.length
      ? [{ category: "Other", permissions }]
      : [];
  },
};

export default mutations;
